module.exports = "<app-nodes-list [nodes]=\"this.nodes$ | async\"></app-nodes-list>"